export const TOASTER_ID = "lox24-toaster";
